import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { AppTranslateService } from '../../services/translate.service';
import { TextToSpeechService } from '../../services/text-to-speech.service';
import { Flashcard } from '../../entities/wordcard.model';
import { User } from '../../entities/user.model';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-flash-card-modal',
  templateUrl: './flash-card-modal.component.html',
  imports: [IonicModule, CommonModule, TranslateModule],
  standalone: true,
  styleUrls: ['./flash-card-modal.component.scss'],
})
export class FlashCardModalComponent implements OnInit {
  @Input() flashcard!: Flashcard;

  error: string | null = null;
  loadingAudio = false;

  constructor(
	private modalController: ModalController,
	private translateService: AppTranslateService,
	private router: Router,
	private textToSpeechService: TextToSpeechService,
  ) {}

  ngOnInit() {}

  closeModal() {
	this.modalController.dismiss();
  }


goToArticle() {
	// Close modal
	this.closeModal();
	this.router.navigate(['/article', this.flashcard.articleId]);
}

/**
 * Vocalize the current flashcard using text-to-speech
 */
async vocalize(): Promise<void> {
	if (!this.flashcard) {
		console.error('No flashcard to vocalize');
		return;
	}

	this.loadingAudio = true;
	
	try {
		const targetLanguage = this.flashcard.targetLanguage || 'en';
		await this.textToSpeechService.vocalizeWordCard(this.flashcard, targetLanguage);
	} catch (error) {
		console.error('Error vocalizing flashcard:', error);
	} finally {
		this.loadingAudio = false;
	}
}

/**
 * Stop audio playback
 */
stopAudio(): void {
	this.textToSpeechService.stopCurrentAudio();
}

/**
 * Check if audio is currently playing
 */
isAudioPlaying(): boolean {
	return this.textToSpeechService.isCurrentlyPlaying();
}

}